import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';
import type { ComponentOrMapping } from '@cfg/pageRoutes.tsx';

export const SupplierListRoute = lazyWithRetry(() => import('@eshop/components/suppliers/SupplierList.tsx'));
export const SupplierDetailRoute = lazyWithRetry(() => import('@eshop/components/suppliers/SupplierDetail.tsx'));
export const SupplierFormRoute = lazyWithRetry(() => import('@eshop/components/suppliers/SupplierForm.tsx'));

const suppliersNode: ComponentOrMapping = {
  '': { component: SupplierListRoute },
  new: { component: SupplierFormRoute },
  ':supplierId': {
    '': { component: SupplierDetailRoute },
    edit: { component: SupplierFormRoute },
  },
};

export const suppliersRouteMapping: ComponentOrMapping = {
  erp: {
    suppliers: suppliersNode,
  },
  app: {
    suppliers: suppliersNode,
  },
};

export default suppliersRouteMapping;
